var _defs, _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 302.73 141.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#GradientFill_4-4);}.cls-2{fill:url(#GradientFill_4-2);}.cls-3{fill:url(#GradientFill_4-3);}.cls-4{fill:#3a3a3a;}.cls-5{fill:url(#GradientFill_1-2);}.cls-5,.cls-6{fill-rule:evenodd;}.cls-6{fill:url(#GradientFill_4-5);}.cls-7{fill:url(#GradientFill_4);}.cls-8{fill:url(#GradientFill_1);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_4",
    x1: 87.06,
    y1: 108.77,
    x2: 124.41,
    y2: 108.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_4-2",
    x1: 129.29,
    x2: 172.36,
    xlinkHref: "#GradientFill_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1",
    x1: 177.26,
    y1: 108.77,
    x2: 214.49,
    y2: 108.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a84c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63b5b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_4-3",
    x1: 219.37,
    x2: 256.72,
    xlinkHref: "#GradientFill_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_4-4",
    x1: 261.6,
    x2: 302.73,
    xlinkHref: "#GradientFill_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_4-5",
    x1: 34.36,
    y1: 131.78,
    x2: 27.92,
    y2: 82.01,
    xlinkHref: "#GradientFill_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1-2",
    x1: 23.9,
    y1: 43.88,
    x2: 78.82,
    y2: 89.68,
    xlinkHref: "#GradientFill_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M124.41,93.65v6.73h-29.1v4.95h25.21v6.62h-25.21v5.21h29.1v6.73h-37.36v-30.25h37.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.65,93.65c2.71,0,5,.86,6.89,2.58,1.9,1.72,2.84,3.8,2.83,6.25v12.58c.01,2.44-.93,4.53-2.83,6.25-1.88,1.72-4.18,2.58-6.89,2.58h-23.65c-2.69,0-4.99-.86-6.89-2.58-1.88-1.72-2.83-3.8-2.83-6.25v-12.58c0-2.44,.94-4.53,2.83-6.25,1.9-1.72,4.2-2.58,6.89-2.58h23.65Zm-23.98,7.77c-.75,.65-1.13,1.48-1.13,2.49v9.71c0,.97,.38,1.81,1.13,2.52,.75,.66,1.67,1,2.76,1.02h18.79c1.1-.04,2.02-.39,2.76-1.04,.75-.71,1.13-1.54,1.13-2.49v-9.71c0-1.02-.38-1.85-1.13-2.52-.74-.72-1.66-1.06-2.76-1.02h-18.79c-1.09-.01-2.01,.33-2.76,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M201.66,93.65l-13.18,19.27h12.74v-9.82h8.26v9.82h5.01v6.73h-5.01v4.24h-8.26v-4.24h-23.95v-5.17l14.33-20.84h10.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.72,93.65v6.73h-29.1v4.95h25.21v6.62h-25.21v5.21h29.1v6.73h-37.36v-30.25h37.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.86,93.65v19.98c0,.97,.38,1.81,1.13,2.52,.75,.66,1.67,1,2.76,1.02h16.84c1.1-.04,2.02-.39,2.76-1.04,.75-.71,1.13-1.54,1.13-2.49v-19.98h8.26v21.42c.01,2.44-.93,4.53-2.83,6.25-1.88,1.72-4.18,2.58-6.89,2.58h-21.7c-2.69,0-4.99-.86-6.89-2.58-1.88-1.72-2.83-3.8-2.83-6.25v-21.42h8.26Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.43,139.46v.42h-4.37v-6.33h4.23v.42h-3.77v2.5h3.37v.41h-3.37v2.6h3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.56,136.88v2.99h-.43v-.84c-.3,.54-.88,.88-1.7,.88-1.06,0-1.7-.54-1.7-1.35,0-.71,.45-1.32,1.76-1.32h1.62v-.38c0-.88-.48-1.35-1.4-1.35-.65,0-1.24,.24-1.63,.6l-.23-.33c.47-.42,1.16-.67,1.89-.67,1.17,0,1.82,.6,1.82,1.76Zm-.45,1.6v-.89h-1.61c-.98,0-1.32,.41-1.32,.95,0,.61,.48,.99,1.31,.99s1.35-.38,1.62-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.93,135.12v.44s-.07,0-.11,0c-1.05,0-1.67,.7-1.67,1.86v2.46h-.45v-4.72h.43v1.03c.29-.69,.91-1.07,1.8-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.01,139.58c-.24,.23-.62,.33-.97,.33-.83,0-1.28-.49-1.28-1.28v-3.08h-.87v-.39h.87v-1.03h.45v1.03h1.5v.39h-1.5v3.04c0,.61,.3,.94,.88,.94,.28,0,.54-.09,.73-.26l.19,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.76,137.12v2.76h-.45v-2.72c0-1.07-.57-1.63-1.53-1.63-1.11,0-1.79,.71-1.79,1.84v2.51h-.45v-6.71h.45v2.97c.33-.64,.98-1.02,1.85-1.02,1.15,0,1.92,.68,1.92,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.03,136.71c0-1.84,1.4-3.21,3.29-3.21s3.29,1.36,3.29,3.21-1.41,3.21-3.29,3.21-3.29-1.37-3.29-3.21Zm6.11,0c0-1.6-1.21-2.79-2.82-2.79s-2.83,1.18-2.83,2.79,1.21,2.79,2.83,2.79,2.82-1.18,2.82-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.04,137.52c0,1.41-1,2.4-2.33,2.4-.85,0-1.56-.42-1.93-1.15v1.11h-.43v-6.71h.45v3.07c.38-.71,1.09-1.11,1.92-1.11,1.33,0,2.33,.98,2.33,2.4Zm-.45,0c0-1.18-.82-1.99-1.91-1.99s-1.9,.8-1.9,1.99,.81,1.99,1.9,1.99,1.91-.81,1.91-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.02,139.31l.21-.36c.36,.31,1,.57,1.7,.57,.99,0,1.39-.35,1.39-.89,0-1.37-3.13-.36-3.13-2.22,0-.71,.6-1.29,1.79-1.29,.6,0,1.25,.18,1.62,.46l-.21,.36c-.4-.29-.91-.42-1.42-.42-.92,0-1.33,.38-1.33,.89,0,1.42,3.13,.42,3.13,2.22,0,.77-.66,1.29-1.86,1.29-.78,0-1.52-.26-1.89-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.3,137.63h-4.06c.05,1.12,.87,1.88,2,1.88,.6,0,1.15-.22,1.51-.66l.26,.3c-.42,.51-1.07,.77-1.78,.77-1.43,0-2.43-.99-2.43-2.4s.97-2.4,2.26-2.4,2.25,.98,2.25,2.38c0,.04,0,.08,0,.13Zm-4.05-.35h3.62c-.06-1.02-.8-1.75-1.81-1.75s-1.74,.72-1.81,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.21,135.12v.44s-.07,0-.11,0c-1.05,0-1.67,.7-1.67,1.86v2.46h-.45v-4.72h.43v1.03c.29-.69,.91-1.07,1.8-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.74,135.16l-2.13,4.72h-.46l-2.12-4.72h.48l1.88,4.22,1.9-4.22h.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.26,136.88v2.99h-.43v-.84c-.3,.54-.88,.88-1.7,.88-1.06,0-1.7-.54-1.7-1.35,0-.71,.45-1.32,1.76-1.32h1.62v-.38c0-.88-.48-1.35-1.4-1.35-.65,0-1.24,.24-1.63,.6l-.23-.33c.47-.42,1.16-.67,1.89-.67,1.17,0,1.82,.6,1.82,1.76Zm-.45,1.6v-.89h-1.61c-.98,0-1.32,.41-1.32,.95,0,.61,.48,.99,1.31,.99s1.35-.38,1.62-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.74,139.58c-.24,.23-.62,.33-.97,.33-.83,0-1.28-.49-1.28-1.28v-3.08h-.87v-.39h.87v-1.03h.45v1.03h1.5v.39h-1.5v3.04c0,.61,.3,.94,.88,.94,.28,0,.54-.09,.73-.26l.19,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.12,133.65c0-.2,.16-.37,.37-.37s.37,.16,.37,.36-.16,.37-.37,.37-.37-.16-.37-.36Zm.14,1.51h.45v4.72h-.45v-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.38,137.52c0-1.4,1-2.4,2.36-2.4s2.36,1,2.36,2.4-1,2.4-2.36,2.4-2.36-.99-2.36-2.4Zm4.26,0c0-1.18-.81-1.99-1.9-1.99s-1.9,.8-1.9,1.99,.81,1.99,1.9,1.99,1.9-.81,1.9-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171,137.12v2.76h-.45v-2.72c0-1.07-.57-1.63-1.53-1.63-1.11,0-1.79,.71-1.79,1.84v2.51h-.45v-4.72h.43v1.02c.32-.66,.98-1.06,1.87-1.06,1.15,0,1.92,.68,1.92,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.87,133.55h2.5c2.01,0,3.36,1.32,3.36,3.17s-1.36,3.17-3.36,3.17h-2.5v-6.33Zm2.47,5.91c1.79,0,2.94-1.14,2.94-2.75s-1.15-2.75-2.94-2.75h-2.01v5.5h2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.88,136.88v2.99h-.43v-.84c-.3,.54-.88,.88-1.7,.88-1.06,0-1.7-.54-1.7-1.35,0-.71,.45-1.32,1.76-1.32h1.62v-.38c0-.88-.48-1.35-1.4-1.35-.65,0-1.24,.24-1.63,.6l-.23-.33c.47-.42,1.16-.67,1.89-.67,1.17,0,1.82,.6,1.82,1.76Zm-.45,1.6v-.89h-1.61c-.98,0-1.32,.41-1.32,.95,0,.61,.48,.99,1.31,.99s1.35-.38,1.62-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.35,139.58c-.24,.23-.62,.33-.97,.33-.83,0-1.28-.49-1.28-1.28v-3.08h-.87v-.39h.87v-1.03h.45v1.03h1.5v.39h-1.5v3.04c0,.61,.3,.94,.88,.94,.28,0,.54-.09,.73-.26l.19,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.29,136.88v2.99h-.43v-.84c-.3,.54-.88,.88-1.7,.88-1.06,0-1.7-.54-1.7-1.35,0-.71,.45-1.32,1.76-1.32h1.62v-.38c0-.88-.48-1.35-1.4-1.35-.65,0-1.24,.24-1.63,.6l-.23-.33c.47-.42,1.16-.67,1.89-.67,1.17,0,1.82,.6,1.82,1.76Zm-.45,1.6v-.89h-1.61c-.98,0-1.32,.41-1.32,.95,0,.61,.48,.99,1.31,.99s1.35-.38,1.62-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.61,139.97l-.91-.96c-.51,.61-1.24,.91-2.11,.91-1.2,0-2.06-.64-2.06-1.58,0-.73,.43-1.28,1.64-1.99v-.02c-.65-.67-.82-1.04-.82-1.53,0-.78,.58-1.29,1.5-1.29,.85,0,1.39,.45,1.39,1.2,0,.62-.37,1.06-1.45,1.69l1.87,1.98c.2-.35,.35-.78,.45-1.28l.37,.12c-.12,.58-.3,1.07-.54,1.46l.94,.99-.27,.3Zm-1.18-1.25l-2-2.11c-1.12,.66-1.46,1.08-1.46,1.69,0,.74,.67,1.24,1.64,1.24,.75,0,1.37-.27,1.82-.82Zm-1.9-2.59c.99-.58,1.31-.91,1.31-1.41s-.35-.86-.99-.86c-.68,0-1.08,.38-1.08,.94,0,.4,.15,.69,.76,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.31,139.06l.21-.34c.43,.45,1.24,.8,2.09,.8,1.27,0,1.83-.55,1.83-1.24,0-1.9-3.95-.76-3.95-3.09,0-.9,.69-1.68,2.24-1.68,.7,0,1.42,.22,1.91,.57l-.17,.37c-.52-.36-1.17-.53-1.74-.53-1.23,0-1.78,.57-1.78,1.27,0,1.9,3.95,.78,3.95,3.07,0,.89-.71,1.67-2.28,1.67-.94,0-1.84-.35-2.31-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.58,137.63h-4.06c.05,1.12,.87,1.88,2,1.88,.6,0,1.15-.22,1.51-.66l.26,.3c-.42,.51-1.07,.77-1.78,.77-1.43,0-2.43-.99-2.43-2.4s.97-2.4,2.26-2.4,2.25,.98,2.25,2.38c0,.04,0,.08,0,.13Zm-4.05-.35h3.62c-.06-1.02-.8-1.75-1.81-1.75s-1.74,.72-1.81,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.49,135.12v.44s-.07,0-.11,0c-1.05,0-1.67,.7-1.67,1.86v2.46h-.45v-4.72h.43v1.03c.29-.69,.91-1.07,1.8-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.02,135.16l-2.13,4.72h-.46l-2.12-4.72h.48l1.88,4.22,1.9-4.22h.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.13,133.65c0-.2,.16-.37,.37-.37s.37,.16,.37,.36-.16,.37-.37,.37-.37-.16-.37-.36Zm.14,1.51h.45v4.72h-.45v-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.39,137.52c0-1.41,1-2.4,2.39-2.4,.75,0,1.4,.29,1.79,.87l-.33,.24c-.34-.48-.87-.71-1.46-.71-1.11,0-1.93,.8-1.93,1.99s.81,1.99,1.93,1.99c.59,0,1.11-.23,1.46-.71l.33,.24c-.39,.57-1.04,.87-1.79,.87-1.38,0-2.39-.99-2.39-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.1,137.63h-4.06c.05,1.12,.87,1.88,2,1.88,.6,0,1.15-.22,1.51-.66l.26,.3c-.42,.51-1.07,.77-1.78,.77-1.43,0-2.43-.99-2.43-2.4s.97-2.4,2.26-2.4,2.25,.98,2.25,2.38c0,.04,0,.08,0,.13Zm-4.05-.35h3.62c-.06-1.02-.8-1.75-1.81-1.75s-1.74,.72-1.81,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.44,138.1h-3.67l-.8,1.78h-.5l2.91-6.33h.46l2.91,6.33h-.5l-.81-1.78Zm-.17-.39l-1.66-3.65-1.66,3.65h3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M252.47,137.52c0-1.41,1-2.4,2.39-2.4,.75,0,1.4,.29,1.79,.87l-.33,.24c-.34-.48-.87-.71-1.46-.71-1.11,0-1.93,.8-1.93,1.99s.81,1.99,1.93,1.99c.59,0,1.11-.23,1.46-.71l.33,.24c-.39,.57-1.04,.87-1.79,.87-1.38,0-2.39-.99-2.39-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.68,137.52c0-1.41,1-2.4,2.39-2.4,.75,0,1.4,.29,1.79,.87l-.33,.24c-.34-.48-.87-.71-1.46-.71-1.11,0-1.93,.8-1.93,1.99s.81,1.99,1.93,1.99c.59,0,1.11-.23,1.46-.71l.33,.24c-.39,.57-1.04,.87-1.79,.87-1.38,0-2.39-.99-2.39-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.39,137.63h-4.06c.05,1.12,.87,1.88,2,1.88,.6,0,1.15-.22,1.51-.66l.26,.3c-.42,.51-1.07,.77-1.78,.77-1.43,0-2.43-.99-2.43-2.4s.97-2.4,2.26-2.4,2.25,.98,2.25,2.38c0,.04,0,.08,0,.13Zm-4.05-.35h3.62c-.06-1.02-.8-1.75-1.81-1.75s-1.74,.72-1.81,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.38,139.31l.21-.36c.36,.31,1,.57,1.7,.57,.99,0,1.39-.35,1.39-.89,0-1.37-3.13-.36-3.13-2.22,0-.71,.6-1.29,1.79-1.29,.6,0,1.25,.18,1.62,.46l-.21,.36c-.4-.29-.91-.42-1.42-.42-.92,0-1.33,.38-1.33,.89,0,1.42,3.13,.42,3.13,2.22,0,.77-.66,1.29-1.86,1.29-.78,0-1.52-.26-1.89-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272.97,139.31l.21-.36c.36,.31,1,.57,1.7,.57,.99,0,1.39-.35,1.39-.89,0-1.37-3.13-.36-3.13-2.22,0-.71,.6-1.29,1.79-1.29,.6,0,1.25,.18,1.62,.46l-.21,.36c-.4-.29-.91-.42-1.42-.42-.92,0-1.33,.38-1.33,.89,0,1.42,3.13,.42,3.13,2.22,0,.77-.66,1.29-1.86,1.29-.78,0-1.52-.26-1.89-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.11,133.65c0-.2,.16-.37,.37-.37s.37,.16,.37,.36-.16,.37-.37,.37-.37-.16-.37-.36Zm.14,1.51h.45v4.72h-.45v-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M285.59,137.52c0,1.41-1,2.4-2.33,2.4-.85,0-1.56-.42-1.93-1.15v1.11h-.43v-6.71h.45v3.07c.38-.71,1.09-1.11,1.92-1.11,1.33,0,2.33,.98,2.33,2.4Zm-.45,0c0-1.18-.82-1.99-1.91-1.99s-1.9,.8-1.9,1.99,.81,1.99,1.9,1.99,1.91-.81,1.91-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M287.12,133.65c0-.2,.16-.37,.37-.37s.37,.16,.37,.36-.16,.37-.37,.37-.37-.16-.37-.36Zm.14,1.51h.45v4.72h-.45v-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.9,133.17h.45v6.71h-.45v-6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.39,133.65c0-.2,.16-.37,.37-.37s.37,.16,.37,.36-.16,.37-.37,.37-.37-.16-.37-.36Zm.14,1.51h.45v4.72h-.45v-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.5,139.58c-.24,.23-.62,.33-.97,.33-.83,0-1.28-.49-1.28-1.28v-3.08h-.87v-.39h.87v-1.03h.45v1.03h1.5v.39h-1.5v3.04c0,.61,.3,.94,.88,.94,.28,0,.54-.09,.73-.26l.19,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M302.73,135.16l-2.42,5.36c-.38,.87-.85,1.15-1.47,1.15-.43,0-.82-.14-1.09-.42l.23-.34c.24,.25,.52,.37,.88,.37,.43,0,.75-.2,1.04-.84l.25-.57-2.12-4.7h.48l1.89,4.22,1.89-4.22h.46Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.42,74.38c.21-7.87-1.49-13.74-5.09-17.6-3.45,6.68-6.01,14.47-6.87,23.69,.29,2.51,.73,5.03,1.32,7.54,1.87,7.99,5.11,15.36,9.43,21.9-3.54-12.34-3.13-24.18,1.21-35.52h0Zm29.17-9.06c-23.79,25.02-26.17,47.08-7.15,66.19,5.81,3.27,12.13,5.69,18.77,7.13-24.33-14.47-23.77-33.03,1.68-55.69,.84-8.44-4.95-16.11-13.3-17.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.64,44.01c-2.93,2.12-7.72,5.6-14.39,10.43-9.72,7.05,1.71,25.02,10.65,18.67,7.49-5.32,12.62-8.97,15.4-10.94,8.49-6.03-1.36-25.62-11.66-18.16h0Zm-50.75,38.95c5.07-4.51,11.13-9.19,18.17-14.02,10.39-7.15,20.41,9.88,11.09,16.98-37.76,28.81-42.51,46.89-14.24,54.22-5.71,.2-11.31-.32-16.7-1.48-24.33-14.47-23.77-33.03,1.68-55.69h0Zm16.31-63.42c9.3-4.95,18.29,8.25,8.59,14.76-16.07,10.8-28.8,21.15-38.2,31.03-23.79,25.02-26.17,47.08-7.15,66.19-9.3-5.23-17.29-12.62-23.24-21.61-3.54-12.34-3.13-24.18,1.21-35.52,7.59-19.8,27.18-38.08,58.78-54.85h0ZM7.33,56.78C20.58,31.11,46.89,21.9,39.77,11.11,12.71,23.31-2.93,51.56,.46,80.47c.86-9.22,3.42-17.01,6.87-23.69h0ZM62.89,.22c3.41-.7,6.49,.3,6.89,2.23,.4,1.93-2.05,4.05-5.46,4.75-3.41,.7-6.49-.3-6.89-2.23-.39-1.93,2.05-4.05,5.46-4.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae9561505d40664934c6c114e664c149.svg";
export { ForwardRef as ReactComponent };